import React from "react";
import { ITransactionUserSummary } from "@eagerdog/interfaces";
import { AgGridReact } from "ag-grid-react";
import { type ColDef } from "ag-grid-community";

import styles from "./StoreTransactionsTab.module.scss";

interface IProps {
  data: {
    transaction: ITransactionUserSummary;
  };
}

interface IItemRow {
  item_name: string;
  quantity: number;
  fee: string;
}

export const TransactionDetailRenderer: React.FC<IProps> = ({ data }) => {
  const transaction = data.transaction;

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: transaction.amounts.currency.toUpperCase(),
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  const itemRows: IItemRow[] = transaction.add_ons?.map((addOn: any) => ({
    item_name: addOn.title || 'Unknown Item',
    quantity: addOn.quantity || 0,
    fee: formatter.format((addOn.fee || 0))
  })) || [];

  const colDefs: ColDef<IItemRow>[] = [
    {
      field: "item_name",
      headerName: "Item Name",
      flex: 2,
    },
    {
      field: "quantity",
      headerName: "Quantity",
      flex: 1,
    },
    {
      field: "fee",
      headerName: "Price",
      flex: 1,
    },
  ];

  return (
    <div className={styles.detailGrid}>
      <AgGridReact
        rowData={itemRows}
        columnDefs={colDefs}
        domLayout="autoHeight"
        headerHeight={28}
        rowHeight={32}
        suppressCellFocus={true}
        suppressRowHoverHighlight={false}
      />
    </div>
  );
};

